<template>
  <nav aria-label="Main Navigation Bar" :class="`hc-nav ${route.meta.theme} ${mobileOpenMenu ? 'open' : ''} ${route.path == '/searchJob' ? 'background-white' : ''}`">
    <div class="hc-nav__container">
      <NavBarRightLogo />
      <div class="hc-nav__wrapper" @click="hiddenMobileMenu" @scroll="hiddenMobileMenu">
        <div class="hc-nav__menu">
          <template v-if="device === 'pc'">
            <div class="hc-nav__menu-parent" v-for="menuItem in menuList">
              <div :class="`hc-nav__menu-item ${route.path === menuItem.path ? 'active' : ''}`">
                <div class="hc-nav__header-link">
                  <router-link :to="menuItem.path" v-if="menuItem.type === 'in'">
                    {{ menuItem.title }}
                  </router-link>
                  <a v-else href="javascript:void(0)" @click="goPath(menuItem.path)"> {{ menuItem.title }}</a>
                </div>
              </div>

            </div>
          </template>
          <template v-else>
            <div class="hc-nav__menu-parent" v-for="mobileMenuItem in mobileMenuList">
              <div class="hc-nav__menu-item">

                <div class="hc-nav__header-link mobile_link" @click="goPath(mobileMenuItem.path)">
                  <!-- {{ mobileMenuItem.title }} -->
                  <CommonButton buttonType="tertiary" :buttonText="mobileMenuItem.title" />
                </div>
              </div>
            </div>
            <div class="hc-nav__menu-parent bottom-padding">
              <div class="hc-nav__menu-item">
                <div class="hc-nav__header-link change_lang">
                  {{ $t("navUtili.language") }}
                  <div class="lang_items">
                    <div :class="`lang_item  ${locale === 'cn' && 'active'}`" @click="changeLang('cn')">
                      中文
                    </div>
                    <div :class="`lang_item  ${locale === 'en' && 'active'}`" @click="changeLang('en')">
                      English
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="hc-nav__search hc-nav__search--mobile">
            <div class="wp-block-button is-style-btn-primary-action">
              <router-link class="wp-block-button__link wp-element-button" to="searchJob"><span class="text">{{
                $t("searchjobs") }}</span><span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 18 18">
                    <path fill="#000"
                      d="M17.681 4.598a1.091 1.091 0 0 0-1.874.741l-.142 8.783L2.058.514A1.091 1.091 0 0 0 .515 2.057l13.607 13.608-8.782.141a1.091 1.091 0 0 0 .035 2.182l11.357-.184a1.09 1.09 0 0 0 1.073-1.073l.184-11.357c.005-.3-.114-.575-.308-.776Z">
                    </path>
                  </svg></span></router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="hc-nav__right">

        <div class="hc-nav__search">
          <div class="wp-block-button is-style-btn-primary-action">
            <router-link to="searchJob" class="wp-block-button__link wp-element-button"><span class="text">{{
              $t("searchjobs")
                }}</span><span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                  <path fill="#000"
                    d="M17.681 4.598a1.091 1.091 0 0 0-1.874.741l-.142 8.783L2.058.514A1.091 1.091 0 0 0 .515 2.057l13.607 13.608-8.782.141a1.091 1.091 0 0 0 .035 2.182l11.357-.184a1.09 1.09 0 0 0 1.073-1.073l.184-11.357c.005-.3-.114-.575-.308-.776Z">
                  </path>
                </svg></span></router-link>
          </div>
        </div>
        <div class="hc-nav__mobile-toggle" @click="mobileOpenMenuList">
          <div class="hc-nav__hamburger">
            <span class="line"></span><span class="line"></span><span class="line"></span>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, computed, inject } from 'vue'
import NavBarRightLogo from "./NavBarRightLogo.vue";
import CommonButton from '@/components/CommonButton.vue'
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();

const device = inject('device')

const route = useRoute();

const changeLang = (lang) => {
  localStorage.setItem('language', lang)
  locale.value = lang;
}

const menuList = computed(() => {
  return [
    {
      title: t("router.lifeAtHilton"),
      type: 'in',
      path: "/lifeAtHilton"
    },
    {
      title: t("router.benefits"),
      type: 'in',
      path: "/benefits"
    },
    {
      title: t("router.location"),
      type: 'out',
      path: 'https://hilton-careers-next.go-vip.net',
    },
  ]
})
const mobileMenuList = computed(() => {
  let lang = ''
  if (locale.value === 'en') {
    lang = "en_US"
  } else {
    lang = "zh_CN"
  }
  return [{
    title: t("router.location"),
    path: 'https://hilton-careers-next.go-vip.net',
  }, {
    title: t("router.recruitmentStatus"),
    path: import.meta.env.VITE_APP_APP_HISTORY + '?lang=' + lang,
  },]
})
const goPath = (link) => {
  window.location.href = link
}
const mobileOpenMenu = ref(false)
const mobileOpenMenuList = () => {
  mobileOpenMenu.value = !mobileOpenMenu.value
}
const hiddenMobileMenu = (e) => {
  if (e.target.classList.contains('hc-nav__wrapper')) {
    mobileOpenMenu.value = false
  }
}
</script>

<style lang="scss" scoped>
.mobile_link {
  ::v-deep(.wp-block-buttons .wp-block-button .wp-element-button .arrow svg) {
    height: 14.5px;
  }
}

.background-white {
  background-color: #F0E9E6;
}

@media (max-width: 767px) {
  .hc-nav__menu {
    margin-top: 0px;
  }

  .hc-nav.open .hc-nav__menu {
    display: block;
    width: 100%;
    padding: 0px 20px;
    background-color: #ffffff00;

    .hc-nav__menu-parent {
      background-color: #fff;
      margin-top: -1px;
    }

    .hc-nav__menu-parent:first-child {
      padding-top: 10px;
    }

    .hc-nav__menu-parent.bottom-padding {
      padding-bottom: 10px;
    }
  }

  .wp-block-button .wp-element-button {
    min-height: 40px;
    font-size: 0.85rem;
  }

  .wp-block-button .wp-element-button .text {
    padding: 16px 12px;
  }

  .wp-block-button .wp-element-button .arrow {
    flex: 45px 0 0;
  }

  .wp-block-button .wp-element-button .arrow svg {
    width: 12px;
  }

  .hc-nav__hamburger .line {
    width: 16px;
    margin: 4px auto;
  }

  .hc-nav.open .hc-nav__hamburger .line:first-child {
    transform: translateY(7px);
  }

  .scrolling-up{
      .hc-nav__right {
          .hc-nav__search {
            .wp-block-button .wp-element-button .text {
              padding-left: 21px;
            }
      
            .wp-block-button .wp-element-button .arrow {
              padding-right: 21px;
            }
          }
        }
  }
}
</style>
